module.exports = __webpack_public_path__ + "static/media/bg-icon.e79ad512.svg";